import React from 'react'
import { Link as LinkIcon } from 'lucide-react'
import { toast } from 'sonner'
import { cn } from '@duck/ui'
import { useTar } from '@/modules/i18n'

interface CopyLinkButtonProps {
  /** The public assignment share token. */
  linkToken: string
  className?: string
}

export const CopyLinkButton: React.FC<CopyLinkButtonProps> = ({ linkToken, className }) => {
  const { t } = useTar()
  const url = `${window.location.origin}/?atoken=${linkToken}`
  const onCopy = async (e: React.MouseEvent) => {
    e.stopPropagation() // never trigger the row expand
    try {
      await navigator.clipboard.writeText(url)
      toast.success(t('common.linkCopied'))
    } catch {
      toast.error(t('common.failedToCopyLink') + '\n' + url, { duration: 15000 })
    }
  }
  return (
    <button
      type="button"
      onClick={onCopy}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md border border-primary/40 px-2 py-1 text-xs text-primary hover:bg-primary/10',
        className
      )}
    >
      <LinkIcon className="h-3 w-3" />
      {t('partner.copyPublicLink')}
    </button>
  )
}
